'use strict';

export const helpArticleState = {
	name: 'helpArticlePage',
	templateUrl: 'workspaces/SolutionBuilderAgent/layouts/help-article-page/help-article-page.html',
	url: '/article/:objectId',
	title: 'Help Article Page',
	controllerAs: 'vm',
	controller: 'mx.SolutionBuilderAgent.HelpArticlePageController',
	lazyLoad: async function lazyLoadModules(transition) {
		const $ocLazyLoad = transition.injector().get('$ocLazyLoad');

		const { shellAgentModule } = await import(/* webpackChunkName: "shell" */ '../Shell/shell');
		await $ocLazyLoad.inject(shellAgentModule.name, {}, true);
	},
};
